import React from 'react';
import orderBy from 'lodash/orderBy';
import { Formik, Field, Form } from 'formik';
import { css } from 'react-emotion';
import { withRouter } from 'react-router';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement,
} from 'react-stripe-elements';

const test = css({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 350,
});

// const sideError = css({
//   display: 'block',
//   fontFamily: 'arial',
//   fontSize: '.875rem',
//   color: '#dc3545',
// });

const stripeError = css({
  fontSize: '.875rem',
  color: '#dc3545',
});

const FormGroup = ({ render }) => <div className="form-group">{render()}</div>;

const CheckBoxField = ({ label, help, field, form }) => {
  return (
    <FormGroup
      render={() => (
        <div>
          <div>
            <div className="form-check">
              <input
                type="checkbox"
                className="_form-check-input"
                onChange={e => {
                  form.setFieldValue(field.name, e.currentTarget.checked);
                }}
              />
              <label className="form-check-label" htmlFor={field.name}>
                {label}
              </label>
            </div>
            {form.errors[field.name] && (
              <div className={stripeError}>{form.errors[field.name]}</div>
            )}
          </div>
          {help && <small className="form-text text-muted">{help}</small>}
        </div>
      )}
    />
  );
};

const CardField = ({ label, help, field, form, elementRef, CardElement }) => (
  <FormGroup
    render={() => (
      <div>
        <label htmlFor={field.name}>{label}</label>
        <div>
          <CardElement
            className="form-control"
            onChange={() => {
              // this is ghetto. figure out a better way later
              if (form.errors[field.name]) {
                form.setFieldError('creditcard', '');
              }
            }}
            elementRef={elementRef}
          />
          {form.errors[field.name] && (
            <div className={stripeError}>{form.errors[field.name]}</div>
          )}
        </div>
        {help && <small className="form-text text-muted">{help}</small>}
      </div>
    )}
  />
);

const queryCards = gql`
  query cards($organizationId: ID!) {
    cards(organizationId: $organizationId) {
      id
      organization_id
      brand
      last4
      exp_month
      exp_year
      is_default
      # cardholder_name
      # street
      # street2
      # city
      # postal
      # state
      # country
      # stripe_card_id
      # customer
      # data
    }
  }
`;

const createCard = gql`
  mutation createCard(
    $organizationId: ID!
    $token: String!
    $isDefault: Boolean
  ) {
    createCard(
      organizationId: $organizationId
      token: $token
      isDefault: $isDefault
    ) {
      id
      organization_id
      brand
      last4
      exp_month
      exp_year
      is_default
      # cardholder_name
      # street
      # street2
      # city
      # postal
      # state
      # country
      # stripe_card_id
      # customer
      # data
    }
  }
`;

const withMutation = graphql(createCard, {
  props: ({ mutate }) => ({
    createCard: values => {
      return mutate({
        variables: values,
        update: (proxy, { data: { createCard } }) => {
          const data = proxy.readQuery({
            query: queryCards,
            variables: { organizationId: values.organizationId.toString() },
          });

          proxy.writeQuery({
            query: queryCards,
            variables: { organizationId: values.organizationId.toString() },
            data: {
              cards: orderBy(
                [
                  ...data.cards.map(c => ({
                    ...c,
                    ...(createCard.is_default ? { is_default: false } : {}),
                  })),
                  createCard,
                ],
                ['id'],
                ['desc'],
              ),
            },
          });
          // TODO: is the user being saved correctly locally?

          // const query = queryNotifications;
          // const variables = { id: notificationId };
          // const data = proxy.readQuery({ query, variables });
          // readNotification.forEach(rn => {
          //   const index = data.myNotifications.findIndex(n => n.id === rn.id);
          //   if (index > -1) data.myNotifications.splice(index, 1);
          // });
          // proxy.writeQuery({ query, data });
        },
        // TODO: optimisticResponse
      });
    },
  }),
});

// const formikize = graphQLErrors =>
//   graphQLErrors.reduce(
//     (p, c) => ({
//       ...p,
//       [c.path]: c.message,
//     }),
//     {},
//   );

@withRouter
@withMutation
class AddCardForm extends React.Component {
  render() {
    const { createCard, closeModal, params: { organizationId } } = this.props;

    return (
      <Formik
        initialValues={{
          payment_type: 'credit',
          organizationId,
          isDefault: false,
        }}
        onSubmit={async (
          values,
          {
            setSubmitting,
            setErrors,
            setFieldError /* setValues and other goodies */,
          },
        ) => {
          setSubmitting(true);
          console.log('vals', values);
          if (values.payment_type === 'credit') {
            try {
              const payload = await this.props.stripe.createToken();
              console.log('payload', payload);
              if (payload && payload.error) {
                console.log(payload.error);
                // STRIPE ERROR CODES: https://stripe.com/docs/api/node#errors
                switch (payload.error.code) {
                  case 'incomplete_number':
                  case 'invalid_number':
                    setFieldError('creditcard', payload.error.message);
                    break;
                  case 'incomplete_expiry':
                  case 'invalid_expiry_month':
                  case 'invalid_expiry_year':
                    setFieldError('expiration', payload.error.message);
                    break;
                  case 'incomplete_cvc':
                  case 'invalid_cvc':
                    setFieldError('cvc', payload.error.message);
                    break;
                  case 'incomplete_zip':
                  case 'incorrect_zip':
                    setFieldError('postal', payload.error.message);
                    break;
                  default:
                    setFieldError('creditcard', payload.error.message);
                }
                setSubmitting(false);
              }
              if (!payload.error) {
                await createCard({
                  organizationId,
                  token: payload.token.id,
                  isDefault: values.isDefault,
                });
                setSubmitting(false);
                if (closeModal) {
                  closeModal();
                }
                // this._element.clear();
              }
            } catch (e) {
              console.log('e', e);
              throw e;
            }
          }
        }}
        render={({ values, setFieldValue, isSubmitting }) => (
          <Form className={test}>
            {/* <div style={{ marginBottom: 16 }}>
              <label htmlFor="payment_type">Payment Type</label>
              <Field
                name="payment_type"
                component="select"
                className="form-control"
                style={{ maxWidth: 500 }}
              >
                <option value="credit">Credit</option>
              </Field>
            </div> */}
            <Field
              label="Credit Card"
              component={CardField}
              CardElement={CardNumberElement}
              name="creditcard"
              elementRef={c => (this._element = c)}
            />
            <Field
              label="Expiration date"
              component={CardField}
              CardElement={CardExpiryElement}
              name="creditcard"
              elementRef={c => (this._element = c)}
            />
            <Field
              label="CVC"
              component={CardField}
              CardElement={CardCVCElement}
              name="creditcard"
              elementRef={c => (this._element = c)}
            />
            <Field
              label="Postal Code"
              component={CardField}
              CardElement={PostalCodeElement}
              name="creditcard"
              elementRef={c => (this._element = c)}
            />
            <Field
              label="Make Active"
              component={CheckBoxField}
              name="isDefault"
            />
            <div className="form-group row justify-content-end">
              <button
                className="btn btn-primary"
                type="submit"
                disabled={isSubmitting}
              >
                {!isSubmitting && 'Add Card'}
                {isSubmitting && (
                  <span>
                    <i className="fa fa-spinner fa-pulse fa-fw" /> Add Card
                  </span>
                )}
              </button>
            </div>
          </Form>
        )}
      />
    );
  }
}

export default AddCardForm;



// WEBPACK FOOTER //
// ./src/views/Admin/AddCardForm.js